



























































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Field, Dialog, Loading, Toast } from "vant";
import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
import VerifyPasswordDialog from "@/components/VerifyPasswordDialog.vue";
import {webViewRightButton} from "@/utils/hybirdMethods";
import customField from "@/components/customField/index.vue";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import amountDisplay from "@/mixins/amountDisplay";

@Component({
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Loading.name]: Loading,
    CustomSelect,
    VerifyPasswordDialog,
    [customField.name]: customField,
    passwordErrorPrompt,
  },
  mixins: [
    amountDisplay
  ],
})
export default class Transfer extends Vue {

  fade_out_account:any = null;
  isLoading = true;
  accountList:any = null;
  accountColumns = [];
  fadeOutColumns:any = [];
  fade_out_usd:any = null;
  fade_out_hkd:any = null;
  fade_out_cnh:any = null;
  fade_in_account:any = null;
  fadeInColumns:any = [];
  fade_out_arreny:any = null;
  arrenyColumns:any = [];
  amount:any = null;
  isSubmitDisabled:any = true;
  showVerifyPasswordDialog:any = false;
  Trpassword:any = null;
  fadeOutType:any = null;
  fadeInType:any = null;

  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ''
  }

  amountIsAll = false;



  created() {
    this.getAccountList();
    // webViewRightButton({"url":{"type":1, "url":"/transfer-record"},"isDisplay":"true","title":this.$t('transfer.rightBtn')})


  }

  // get isShowAllAmount(){
  //   const { remittance_currency } = this.form;
  //   const obj = {
  //     USD: "usd_can_draw",
  //     HKD: "hkd_can_draw",
  //     CNH: "cnh_can_draw"
  //   };
  //   return this.qh[obj[remittance_currency]] > 0;
  // }
  // 是否显示全部余额
  // 对应币种可转出金额 大于0 支持全部余额标签



  get isShowAllAmount(){
    const { fade_out_arreny, fade_out_usd, fade_out_hkd, fade_out_cnh } = this;
    const obj = {
      USD: fade_out_usd,
      HKD: fade_out_hkd,
      CNH: fade_out_cnh
    };
    return obj[fade_out_arreny] > 0;
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }
  get bgColorDialog(){
    return this.bgColor == 'black-theme' ? 'black-theme-dialog' : ''
  }

  getAccountList(){
  	  (this as any).$apis.getAccountLists().then(res =>{
		 this.fadeOutColumns = []
		 this.fadeInColumns = []
		 this.accountColumns = res.accountInfo
		 this.fadeOutType = res.accountInfo.find(item => item.account_type == this.$route.query.account_type).account_type
		 res.accountInfo.forEach(item =>{
			this.fadeOutColumns.push({text:`${item.account_type === 1 ? this.$t("funds.accountName[0]"):this.$t("funds.accountName[1]")}(${item.account_no})`,account_type:item.account_type,value:item.account_no})
			if(item.account_no !== this.$route.query.account_no){
			   this.fadeInColumns.push({text:`${item.account_type === 1 ? this.$t("funds.accountName[0]"):this.$t("funds.accountName[1]")}(${item.account_no})`,account_type:item.account_type,value:item.account_no})
			}
		 })
		 this.fade_out_account = this.$route.query.account_no
		 this.fade_out_usd = res.accountInfo.find(item => item.account_no === this.$route.query.account_no).usd_can_draw || '-'
		 this.fade_out_hkd = res.accountInfo.find(item => item.account_no === this.$route.query.account_no).hkd_can_draw || '-'
		 this.fade_out_cnh = res.accountInfo.find(item => item.account_no === this.$route.query.account_no).cnh_can_draw || '-'

		 this.arrenyColumns = [
			 {
			 	text:this.$t('transfer.arreny_name[0]'),
			 	value:'USD'
			 },
			 {
			 	text:this.$t('transfer.arreny_name[1]'),
			 	value:'HKD'
			 },
			 {
			 	text:this.$t('transfer.arreny_name[2]'),
			 	value:'CNH'
			 }
		 ]
        const query = `account=${this.fade_out_account}&account_type=${this.fadeOutType}`;
        webViewRightButton({"url":{"type":1, "url":"/transfer-record?" + query},"isDisplay":"true","title":this.$t('transfer.rightBtn')})


      })
  }

  handFadeOutChange(){
	  this.fadeInColumns = [];
	  this.fade_in_account = null;
	  // let that = this;
	  setTimeout(() =>{
		this.fade_out_usd = (this as any).accountColumns.find(item => item.account_no === this.fade_out_account).usd_can_draw || '-';
		this.fade_out_hkd = (this as any).accountColumns.find(item => item.account_no === this.fade_out_account).hkd_can_draw || '-';
		this.fade_out_cnh = (this as any).accountColumns.find(item => item.account_no === this.fade_out_account).cnh_can_draw || '-';
		// this.fadeOutType = (this as any).accountColumns.find(item => item.account_no === this.fade_out_account).account_type
		this.fadeOutType = (this as any).accountColumns.find(item => item.account_no === this.fade_out_account).account_type || '-';
		(this as any).accountColumns.forEach(item =>{
			if(item.account_no !== this.fade_out_account){
			   this.fadeInColumns.push({text:`${item.account_type === 1 ? this.$t("funds.accountName[0]"):this.$t("funds.accountName[1]")}(${item.account_no})`,account_type:item.account_type,value:item.account_no})
			}
		})
		if(this.fade_in_account && this.fade_out_account && this.amount && this.fade_out_arreny){
		   this.isSubmitDisabled = false
		}else{
		   this.isSubmitDisabled = true
		}
      const query = `account=${this.fade_out_account}&account_type=${this.fadeOutType}`;
      webViewRightButton({"url":{"type":1, "url":"/transfer-record?" + query},"isDisplay":"true","title":this.$t('transfer.rightBtn')})


    },200)

  }
  handFadeInChange(){
	setTimeout(() =>{
		this.fadeInType = (this as any).accountColumns.find(item => item.account_no === this.fade_in_account).account_type
		if(this.fade_in_account && this.fade_out_account && this.amount && this.fade_out_arreny){
		   this.isSubmitDisabled = false
		}else{
		   this.isSubmitDisabled = true
		}},200)
  }

  handArrenyChange(){
	setTimeout(() =>{
		if(this.fade_in_account && this.fade_out_account && this.amount && this.fade_out_arreny){
		   this.isSubmitDisabled = false
		}else{
		   this.isSubmitDisabled = true
		}
	},200)
  }
  handAmoutChange(){
	 setTimeout(() =>{
	 	if(this.fade_in_account && this.fade_out_account && this.amount && this.fade_out_arreny){
	 	   this.isSubmitDisabled = false
	 	}else{
	 	   this.isSubmitDisabled = true
	 	}
	 },200)
  }



  handleStep(){
	  
	// if(this.fade_out_arreny === 'USD' && this.amount > this.fade_out_usd){
	//     return this.$toast.fail(this.$t('transfer.toast_amout'))
	// }else if(this.fade_out_arreny === 'HKD' && this.amount > this.fade_out_hkd){
	// 	return this.$toast.fail(this.$t('transfer.toast_amout'))
	// }else if(this.fade_out_arreny === 'cnh' && this.amount > this.fade_out_cnh){
	// 	return this.$toast.fail(this.$t('transfer.toast_amout'))
	// }else if(this.amount < 0){
	// 	return this.$toast.fail(this.$t('transfer.toast_amout1'))
	// }else{
	// 	this.showVerifyPasswordDialog = true
	// 	// if((this as any).fadeOutType == 1){
	// 	// }else{
	// 	// 	(this as any).$apis.postTransferOrder({
	// 	// 		a_account:(this as any).fadeOutType == 1 ? (this as any).fade_out_account : (this as any).fade_in_account,
	// 	// 		b_account:(this as any).fadeOutType != 1 ? (this as any).fade_out_account : (this as any).fade_in_account,
	// 	// 		amount:(this as any).amount,
	// 	// 		type:(this as any).fadeOutType,
	// 	// 		transfer_currency:(this as any).fade_out_arreny
	// 	// 	}).then(() =>{
	// 	// 		Dialog.alert({
	// 	// 		  ["message" as any]: this.$t("transfer.confim_message"),
	// 	// 		  ["confirmButtonText" as any]: (this as any).$t('transfer.confim'),
	// 	// 		  ["className" as any]: (this as any).bgColor !== 'white-theme' ? 'black-theme-dialog' : ''
	// 	// 		})
	// 	// 		  .then(() => {
	// 	// 		    this.$router.go(-1);
	// 	// 		  })
	// 	// 		  .catch(() => {
	// 	// 		    // on cancel
	// 	// 		  });
	// 	// 	})
	// 	// }

	// }
	this.showVerifyPasswordDialog = true
  }
  handForgotPwd(){
	this.$router.push({
		path:'/trade-password-reset',
		query:{
			account_type:this.fadeOutType
		}
	})
  }
  handConfim(){
	  (this as any).$apis
	    .checkPasswordFail({
	      password: this.Trpassword
	    })
	    .then((res) => {
        // TODO: 资金划转-登录错误 Code 100173
        // TODO: 资金划转-登录错误，冻结 Code 100174
        if(res.code){
          if( res.code === 100174 || res.code === 100173 ){
            this.pwdErrPromptOption.errCode = res.code;
            this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
            this.pwdErrPromptOption.show = true;
            (this as any).$refs['password-error-prompt-el'].show = true;
            return
          }
        }
          const a_account = (this as any).fade_out_account;
          const b_account = (this as any).fade_in_account;
          const a_account_type = (this as any).accountColumns.find(item => item.account_no === a_account).account_type;
          const b_account_type = (this as any).accountColumns.find(item => item.account_no === b_account).account_type;
	  			(this as any).$apis.postTransferOrder({
            a_account,
	  				b_account,
	  				amount:(this as any).amountIsAll ? 0 : (this as any).amount,
	  				type:(this as any).fadeOutType,
	  				transfer_currency:(this as any).fade_out_arreny,
            a_account_type,
            b_account_type,
            is_all: (this as any).amountIsAll ? 1 : 0
	  			}).then(() =>{
            Dialog.alert({
              ["message" as any]: this.$t("transfer.confim_message"),
              ["confirmButtonText" as any]: (this as any).$t('transfer.confim'),
              ["className" as any]:(this as any).bgColor == 'black-theme' ? 'black-theme-dialog' : ''
            })
              .then(() => {
                this.$router.go(-1);
              })
              .catch(() => {
                // on cancel
              });
	  			})
	    }).catch(e => {
	      

	    });
  }

  passwordErrorPromptConfirm(errCode){
    (this as any).pwdErrPromptOption.show = false;
    if(errCode === 100173){
      (this as any).Trpassword = '';
      (this as any).showVerifyPasswordDialog = true;
      (this as any).$refs['custom-field-password'].setInputFocus();
	  setTimeout(() =>{
	     (this as any).$refs['custom-field-password'].setInputFocus();
	  },500)
    }
  }

  /**
   * @Description 金额千分位显示
   * @date 2024/2/5
   * @param {string|number} num
   * @return {void}
   */
  amountDisplay(num) {
    if (isNaN(num)) {
      // 兼容，num 存在 '-' 的情况。
      return num
    } else {
      return (this as any).mixinAmountDisplay(num)
    }
  }
  // 全部金额
  setAmountIsAll(){
    (this as any).amountIsAll = !(this as any).amountIsAll;
    (this as any).amount = (this as any).amountIsAll ? (this as any).$t("withdraw.all_amount") : "";
    (this as any).handAmoutChange();
  }

  clearAmount(){
    (this as any).amountIsAll = false;
  }


}
